'use strict';

const Backbone = require('backbone');
const ViewerModel = require('balus/domain/entity/viewer');

module.exports = Backbone.Collection.extend({
    /**
     * Diagram を同時に閲覧している人を保持する Collection
     */
    url: null,
    model: ViewerModel,

    initialize: function() {
        this._users = new Backbone.Collection();
        this.updateUsers();
        this.listenTo(this, 'add', this.updateUsers);
        this.listenTo(this, 'remove', this.updateUsers);
        this.listenTo(this, 'reset', this.updateUsers);
    },

    getUsers: function() {
        return this._users;
    },

    updateUsers: function() {
        let users = new Backbone.Collection();
        this.each(v => {
            users.add(v.getUser());
        });
        this._users.reset(users.models);
    },

    comparator: function(item) {
        return item.id;
    }
});



// WEBPACK FOOTER //
// ./balus/domain/collection/viewer.js